import { Types } from "../actions/notificationActions";
import _ from "lodash";

//import { v4 as uuidv4 } from 'uuid';

const defaultState = {
};

const notificationsReducers = (state = defaultState, action) => {
    switch (action.type) {
        case Types.NOTIFICATION_LOADING: {
            let newState = _.cloneDeep(state);

            newState.notifications.loading = action.status ? action.status : undefined;
            return newState;
        }
        case Types.NOTIFICATION_SINGLE_LOADING: {
            let newState = _.cloneDeep(state);

            newState.notifications.notification = {
                loading: action.status ? action.status : undefined
            }
            return newState;
        }
        case Types.NOTIFICATION_LIST: {
            let newState = _.cloneDeep(state);
            newState.notifications.loading = undefined;
            newState.notifications.list = action.list;
            return newState;
        }
        case Types.NOTIFICATION_ENTRY: {
            let newState = _.cloneDeep(state);

            newState.notifications.notification = action.response?.id ? action.response : undefined;
            return newState;
        }
        default:
            return state;
    }
};

export default notificationsReducers;